import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { useMutation } from '@apollo/client';
import { gql } from '../graphql/generated/gql';
import { PostType } from '../graphql/generated/graphql';
import { useAddRecentlyUsedTemplateId } from '../ui/atoms';
import useNavigate from '../utils/router/useNavigate';
import postPath from '../utils/url/postPath';

const CREATE_POST_MUTATION = gql(/** @complexity 2 */ `
  mutation createPost(
    $topicId: ID
    $libraryName: String
    $type: PostType
    $templateId: ID
  ) {
    post: createPost(
      topicId: $topicId
      libraryName: $libraryName
      type: $type
      templateId: $templateId
    ) {
      id
      shareSecret
      ...postPath_post
    }
  }
`);

const CreatePostView = () => {
  const [searchParams] = useSearchParams();
  const templateId = searchParams.get('templateId');
  const library = searchParams.get('library');
  const topicId = searchParams.get('topicId');
  const type = searchParams.get('type');

  const [createPost] = useMutation(CREATE_POST_MUTATION, {
    variables: {
      topicId,
      libraryName: library,
      type: type === 'template' ? PostType.Template : PostType.Post,
      templateId,
    },
  });

  const addRecentlyUsedTemplateId = useAddRecentlyUsedTemplateId();
  const navigate = useNavigate();

  useEffect(() => {
    createPost().then(({ data }) => {
      if (data?.post) {
        if (templateId) {
          addRecentlyUsedTemplateId(templateId);
        }

        navigate(
          postPath(data.post, {
            shareSecret: data.post.shareSecret ?? undefined,
          }),
          {
            replace: true,
          },
        );
      }
    });
  }, [addRecentlyUsedTemplateId, createPost, navigate, templateId]);

  return null;
};

export default CreatePostView;
